import React from 'react';
import moment from 'moment';
import { RequestIdTableCell } from '../RequestIdTableCell';
import { RequestDaysTableCell } from '../RequestDaysTableCell';
import { RequestId } from './RequestId';
import { TooltipTableCell } from '../TooltipTableCell';

export const RequestIdWithWarning = (dateField = 'created_at') => {
    return {
        Header: () => 'Solicitud',
        typeId: 'HeaderRequest',
        id: 'id',
        Cell: ({ row }) => {
            return (
                <RequestIdTableCell
                    row={row}
                    comparativeDateField={dateField}
                />
            );
        },
    };
};
export const RequestIdWithWarningAliado = () => {
    return {
        Header: () => 'Solicitud',
        id: 'id2',
        Cell: ({ row }) => {
            return (
                <TooltipTableCell label={row.original.pk} showClass={true} />
            );
        },
    };
};
export const replaceRequestId = (columns) => {
    const index = columns.map((e) => e.id).indexOf('id');

    if (~index) {
        columns[index] = RequestId;
    }
    return columns;
};

// export const replaceRequestIdWithoutRedirect = (columns) => {
//     const index = columns.map((e) => e.id).indexOf('id');
//     if (~index) {
//         columns[index] = RequestIdWithoutRedirect;
//     }
//     return columns;
// };

export const RequestDays = (dateField = 'created_at') => {
    return {
        Header: () => 'En Gestión',
        id: 'id_day',
        Cell: ({ row }) => {
            return (
                <RequestDaysTableCell
                    row={row}
                    comparativeDateField={dateField}
                />
            );
        },
    };
};

export const Causales = () => {
    return {
        Header: () => 'Causal',
        id: 'id_causal',
        Cell: ({ row }) => {
            return (
                <span>{row.original.causal ? 'POLÍTICAS INTERNAS' : ''}</span>
            );
        },
    };
};

/**
 * Fecha VoBo:
 *  - Sin fecha_precomite ni fecha_ratificacion -> fecha_ejecutivo
 *  - Solo una de las dos -> esa fecha
 *  - Ambas -> la mayor (la más reciente)
 */
export const getDateVobo = (row) => {
    const ratification = row?.gestionsolicitud?.fecha_ratificacion;
    const precommittee = row?.gestionsolicitud?.fecha_precomite;
    const executive = row?.gestionsolicitud?.fecha_ejecutivo;

    if (!ratification || !precommittee) {
        return ratification || precommittee || executive || '';
    }

    // Formato con el que el backend serializa las fechas de gestionsolicitud
    const dateFormat = 'YYYY-MM-DD hh:mm A';

    const ratificationDate = moment(ratification, dateFormat, true);
    const precommitteeDate = moment(precommittee, dateFormat, true);

    // Si alguna fecha no cumple el formato, se deja rastro en consola y se
    // toma Ratificación porque en el flujo siempre es posterior a Precomité
    if (!ratificationDate.isValid() || !precommitteeDate.isValid()) {
        console.error('Fecha VoBo con formato inesperado', {
            ratification,
            precommittee,
        });
        return ratification;
    }

    return ratificationDate.isSameOrAfter(precommitteeDate)
        ? ratification
        : precommittee;
};

export const DateVobo = () => {
    return {
        Header: () => 'Fecha Vobo',
        accessor: getDateVobo, // misma regla para ordenar y para mostrar
        id: 'id_Vobo',
        Cell: ({ row }) => <span>{getDateVobo(row.original)}</span>,
    };
};
